import {TemplateMode, TemplateStatus} from '@shipwell/template-builder-sdk';
import {useGetListTemplates} from 'App/data-hooks/templates/useGetTemplates';
import {useGenerateDocumentFromTemplate} from 'App/data-hooks/templates/useGenerateDocumentFromTemplate';

interface DocumentOptionsProps {
  shipmentMode: TemplateMode;
  shipmentId: string;
}

export const DocumentOptions = ({shipmentMode, shipmentId}: DocumentOptionsProps) => {
  const {listTemplates} = useGetListTemplates({allowedModesIn: shipmentMode, status: TemplateStatus.Active});

  const templates = listTemplates?.data.data;
  const {generateDocument} = useGenerateDocumentFromTemplate();

  const handleGenerateDocument = (templateId: string) => {
    generateDocument({templateId, shipmentId});
  };

  return (
    <div>
      {templates &&
        templates.map((template) => (
          <button className="mb-2 block" key={template.id} onClick={() => handleGenerateDocument(template.id)}>
            {template.name}
          </button>
        ))}
    </div>
  );
};
